import React from 'react';
import { Router, Route } from 'react-router';

import ShareArticleRoute from './ShareArticleRoute';

import App from './App';

// import './base.scss';

/**
 * The React Router routes for both the server and the client.
 */
const newRoutes = (
  <Router>
    <Route path="/" component={App}>
      <Route path="/share/:docId" component={ShareArticleRoute} />
    </Route>
  </Router>
);
export default newRoutes;
